import { Loader } from "components/common/Icons/Loader/Loader";
import { MemesSearchBox } from "../../LeftBar/MemesList/MemesSearchBox/MemesSearchBox";
import { useMemesList } from "../../LeftBar/MemesList/useMemesList";
import Image from "next/legacy/image";

export const Memes = () => {
    const { memes, isFetching, search, handleSearch, handleClickMeme, handleHorizontalScroll, isFetchingNewPage } =
        useMemesList();
    return (
        <div className="lg:hidden flex flex-col gap-4">
            <MemesSearchBox search={search} handleSearch={handleSearch} />
            <div className="relative flex gap-2 min-h-[115px]">
                {isFetching && (
                    <div className="w-full grid place-items-center">
                        <Loader className="stroke-[var(--dark-gray)]" width={50} height={50} />
                    </div>
                )}
                {memes.length > 0 && !isFetching && (
                    <div
                        className="absolute flex left-0 top-0 h-full min-h-[115px] w-[calc(100%+24px)] gap-2 overflow-x-auto scroll"
                        onScroll={handleHorizontalScroll}
                    >
                        {memes.map((meme) => (
                            <div key={meme.id} className="flex-shrink-0" onClick={() => handleClickMeme(meme)}>
                                <Image src={meme.thumbnailUrl} width={100} height={100} />
                            </div>
                        ))}
                        {isFetchingNewPage && (
                            <div className="h-full grid place-items-center px-4">
                                <Loader className="stroke-[var(--dark-gray)]" width={25} height={25} />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
